module.exports = __webpack_public_path__ + "static/img/strona_038.2850c269.jpg";